import {Injectable} from '@angular/core';

/**
 * Translations for tixx select submission statuses.
 */
@Injectable()
export class TixxSelectSubmissionStatusTranslationsService {
  public i18nAny: any = $localize`:@@general.status.any:Any`;
  public i18nReceivedStatus: any = $localize`:@@general.status.received:Received`;
  public i18nNormal: any = $localize`:@@general.status.normal:Normal`;
  public i18nPrioritized: any = $localize`:@@general.status.prioritized:Prioritized`;
  public i18nDeferred: any = $localize`:@@general.status.deffered:Deffered`;
  public i18nDrawn: any = $localize`:@@general.status.drawn:Drawn`;
  public i18nSuccessful: any = $localize`:@@general.status.successful:Successful`;
  public i18nUnsuccessful: any = $localize`:@@general.status.unsuccessful:Unsuccessful`;
  public i18nHigher: any = $localize`:@@general.status.higher:Higher`;
  public i18nLower: any = $localize`:@@general.status.lower:Lower`;
  public i18nHigherLower: any = $localize`:@@general.status.higherLower:Higher & Lower`;
  public i18nYes: any = $localize`:@@general.status.yes:Yes`;
  public i18nNo: any = $localize`:@@general.status.no:No`;


  constructor() { }
}
